import { buildCustomerPath } from "./customer";

export { CCF_DATA_ENTRY_ROUTE_SEGMENTS } from "@service/shared/ccf-data-entry-routes";

export const CCF_ROUTE_SEGMENTS = {
  root: "ccf",
  calculationId: ":calculationId",
  result: "result",
} as const;

export const buildCcfOverviewPath = (customerId: string): string =>
  `${buildCustomerPath(customerId)}/${CCF_ROUTE_SEGMENTS.root}`;

export const buildCcfCalculationPath = (customerId: string, calculationId: string): string =>
  `${buildCcfOverviewPath(customerId)}/${calculationId}`;

export const buildCcfResultPath = (customerId: string, calculationId: string): string =>
  `${buildCcfCalculationPath(customerId, calculationId)}/${CCF_ROUTE_SEGMENTS.result}`;

export const buildCcfDataEntryPath = (customerId: string, calculationId: string, emissionSourcePath: string): string =>
  `${buildCcfCalculationPath(customerId, calculationId)}/${emissionSourcePath}`;
